import React, { Component } from "react";
import { connect } from "react-redux";
import { routes } from "../General";
import { Button, Card, CardBody, Col, Container, ModalHeader, Row } from "reactstrap";
import Alerts from "../../util/Alerts";
import axios from "axios";

class Zoho extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            tickets: [],
            acctk: "",
            rftk: "",
        };
    }

    componentDidMount() {
        axios
            .get(routes.api + "/tokenZoho")
            .then(resp => {
                this.setState({
                    acctk: resp.data.accessToken,
                    rftk: resp.data.refreshToken,
                });
            })
            .catch(error => {
                this.alert.current.handle_error(error);
            });
    }

    getTickets = () => {
        let query = {
            cdCompania: "1",
            cedula: "1712345678",
            numReclamo: "33.0",
            incapcidad: "dolor corazon",
            cdIncapSiniestro: "16803",
            valorIncurrido: "211,6",
            valorNoCubierto: "2,18",
            deducible: "80",
            coaseguro: "18,93",
            valorPagado: "110,49",
            observaciones: "ninguna",
            usuario: "BROKER",
        };
        // let query = {
        //     cdCompania: 1,
        //     cdIncapSiniestro: "16803",
        //     valorIncurrido: "211,6",
        //     deducible: "80",
        //     coaseguro: "18,93",
        //     valorPagado: "110.49",
        //     observaciones: "ninguna",
        //     usuario: "Broker",
        //     cedula: "1712345678",
        //     incapcidad: "dolor corazon",
        //     numReclamo: "800.0",
        // };
        axios
            .post(routes.api + "/closeSiniestro", query)
            .then(resp => {
                // this.setState({
                //     acctk: resp.data.accessToken,
                //     rftk: resp.data.refreshToken
                // });
            })
            .catch(error => {
                this.alert.current.handle_error(error);
            });
    };

    render() {
        return (
            <div>
                <Alerts ref={this.alert} />
                <div className="content">
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <a href={routes.api + "/loginZoho"} className="btn btn-primary">
                                        Conectar con Zoho
                                    </a>

                                    <Container>
                                        <ModalHeader className="text-center">Tokens</ModalHeader>
                                        <CardBody>
                                            <Row>
                                                <span className="text-center">
                                                    <strong>Token de Acceso: </strong>
                                                    {this.state.acctk}
                                                </span>
                                                <span>
                                                    <strong>Refresh Token: </strong>
                                                    {this.state.rftk}
                                                </span>
                                            </Row>
                                        </CardBody>
                                    </Container>

                                    <br />
                                    <Button onClick={() => this.getTickets()}>Tickets</Button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Zoho);
